/* GIFs play only on request, with a poster for pause, reduced motion and no JS. */
(() => {
  if (window.KaliaMeasuringAnimation) { window.KaliaMeasuringAnimation.start(document); return; }
  const roots = new Set(), states = new Set();
  function stop(state) {
    if (state.timer !== null) window.clearTimeout(state.timer);
    state.timer = null;
    if (state.playing) state.image.setAttribute('src', state.poster);
    state.playing = false;
    state.button.setAttribute('aria-pressed', 'false');
    state.button.setAttribute('aria-label', `Play ${state.mode} mount animation`);
    state.label.textContent = 'Play animation';
  }
  function stopRoot(root) { states.forEach(state => { if (state.root === root) stop(state); }); }
  function start(scope) {
    const found = scope.matches?.('[data-kalia-measuring-animation]') ? [scope] : scope.querySelectorAll('[data-kalia-measuring-animation]');
    found.forEach(root => {
      if (roots.has(root)) return;
      roots.add(root);
      root.querySelectorAll('[data-kma-play]').forEach(button => {
        const panel = button.closest('[data-kma-mode]'), image = panel?.querySelector('[data-kma-image]'), label = button.querySelector('[data-kma-play-label]');
        if (!image || !label) return;
        const gifSource = button.getAttribute('data-kma-gif');
        if (!gifSource) return;
        let gif;
        try { gif = new URL(gifSource, document.baseURI); } catch { return; }
        if (!/^https?:$/.test(gif.protocol)) return;
        const state = { root, button, image, label, mode: panel.getAttribute('data-kma-mode'), poster: image.getAttribute('src'), gif: gif.href, playing: false, timer: null, duration: Math.min(30000, Math.max(1000, Number(button.getAttribute('data-kma-duration')) || 8000)) };
        states.add(state);
        button.hidden = false;
        button.addEventListener('click', () => {
          const wasPlaying = state.playing;
          stopRoot(root);
          if (wasPlaying) return;
          state.playing = true;
          image.setAttribute('src', state.gif);
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', `Pause ${state.mode} mount animation`);
          label.textContent = 'Pause animation';
          state.timer = window.setTimeout(() => stop(state), state.duration);
        });
        image.addEventListener('error', () => {
          if (!state.playing) return;
          stop(state);
          button.hidden = true;
          const status = root.querySelector('[data-kma-status]');
          if (status) { status.textContent = 'Animation unavailable. Follow the steps below.'; status.hidden = false; }
        });
      });
      root.addEventListener('change', event => {
        if (!event.target.matches('[data-kma-choice]')) return;
        event.stopPropagation();
        stopRoot(root);
      });
      root.addEventListener('input', event => {
        if (event.target.matches('[data-kma-choice]')) event.stopPropagation();
      });
      root.closest('dialog')?.addEventListener('close', () => stopRoot(root));
    });
  }
  document.addEventListener('visibilitychange', () => { if (document.hidden) states.forEach(stop); });
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach(state => { if (event.target.contains(state.root)) { stop(state); states.delete(state); } });
    roots.forEach(root => { if (event.target.contains(root)) roots.delete(root); });
  });
  window.KaliaMeasuringAnimation = { start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  else start(document);
})();
